export enum statusNotActive {
  IN_ACTIVE = 0,
  ACTIVE = 1,
}
